<template>
  <div>
     <div class="footer">  
        <div class="footer-bottom">
           <span> © 2009-{{this.year}} 大树联合集团 Powered By <a href="http://www.xiaoxxx.com/">小仙科技</a></span> 
        </div>
      </div>
  </div>
</template>
<script>
export default {
  name:'Backfooter',
  data(){
    return{
      tel:'',
      address:'',
      email:'',
      year:''
    }
  },
  methods:{ 
    
  },
  created(){
    var now = new Date();
    var year = now.getFullYear(); //获取当前年份  
    this.year = year
  }
}
</script>
<style scoped>
.footer{  
  border-top:1px solid grey;
  background: #E9EEF3;
  margin: 10px -20px 0;
  width: 102%;
  min-width: 1200px;
  background-size: cover;
  background-position: center center;
  background-repeat:no-repeat;
  position: absolute;
  bottom:0;
}   
.footer-bottom{
  width: 50%;
  margin:0 15%;
  padding:1% 10%;
  color: grey;
}
.footer-bottom{
  text-align: center;
}  
  .el-dropdown-link {
    cursor: pointer;
    color: white;
    font-size: 16px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  } 
a{
  color: grey;
  } 
a:hover{
  color: black;
}


</style>



// WEBPACK FOOTER //
// src/components/dashu/backfooter.vue